import axios from 'axios'
import Vue from 'vue'
import _ from 'lodash'
import { blobToJson } from '@/lib/blobUtil'

const BOSS_C_URL = process.env.BOSS_C_ENDPOINT
const BOSS_S_URL = process.env.BOSS_S_ENDPOINT
const BOSS_S_ALB_URL = process.env.BOSS_S_ALB_ENDPOINT

const securedAxiosInstance = axios.create({
  baseURL: BOSS_C_URL + '/api',
  withCredentials: true,
  withXSRFToken: true,
  headers: {
    'Content-Type': 'application/json'
  }
})

const plainAxiosInstance = axios.create({
  baseURL: BOSS_C_URL,
  withCredentials: true,
  withXSRFToken: true,
  headers: {
    'Content-Type': 'application/json'
  }
})

securedAxiosInstance.interceptors.request.use((request) => {
  if (window.location.origin === BOSS_S_URL || window.location.origin === BOSS_S_ALB_URL) {
    // BOSS-Sからのアクセスだった場合、APIのホストを変更する
    // パスの先頭に「/web-adm」を付けないとcookie(JSESSIONID)を送信できないため付与しており、
    // WEB層で「/web-adm」のパスをなくしてAPI層にルーティングするようパス変更を実施している
    request.baseURL = window.location.origin + '/web-adm/api/adm'
  }
  return request
})

securedAxiosInstance.interceptors.response.use(null, error => {
  if (window.location.origin === BOSS_S_URL || window.location.origin === BOSS_S_ALB_URL) { // BOSS-Sからのアクセスの場合
    errorHandlingForBossS(error)
  } else {
    errorHandling(error)
  }
  return Promise.reject(error)
})

plainAxiosInstance.interceptors.request.use((request) => {
  if (window.location.origin === BOSS_S_URL || window.location.origin === BOSS_S_ALB_URL) {
    // BOSS-Sからのアクセスだった場合、ホストを変更する
    request.baseURL = window.location.origin
  }
  return request
})

const errorHandling = (error) => {
  if (!error.response || error.response.status === 500) {
    window.location.replace('/#/500')
  } else if (error.response.status === 403) {
    // 認可失敗した場合
    window.location.replace('/#/dashboard')
  } else if (error.response.status === 404) {
    // 404が返却された場合
    window.location.replace('/#/404')
    window.location.reload()
  } else if (error.response.status === 401 || error.response.status === 503) {
    // 認証失敗した場合 またはメンテナンス時
    window.location.hash = '/'
    window.location.reload()
  } else {
    // その他のエラーはトースト
    otherErrorToasted(error)
  }
}

const errorHandlingForBossS = (error) => {
  if (!error.response || error.response.status === 500) {
    window.location.replace('/web-adm/error/500')
  } else if (error.response.status === 403) {
    // 認可失敗した場合
    window.location.replace('/web-adm/error/403')
  } else if (error.response.status === 404) {
    // 404が返却された場合
    window.location.replace('/web-adm/error/404')
  } else if (error.response.status === 401 || error.response.status === 503) {
    // 認証失敗した場合 またはメンテナンス時
    window.location.replace('/')
  } else {
    otherErrorToasted(error)
  }
}

const otherErrorToasted = (error) => {
  if (error.response.config.responseType === 'blob') {
    blobToJson(error.response.data).then(jsonData => {
      errorToasted(jsonData.message)
    })
  } else {
    const message = _.defaultTo(_.get(error, 'response.data.message'), '').replace(/¥n/g, '\n')
    errorToasted(message)
  }
}

const errorToasted = (message) => {
  // 2021/5/24では応募者一覧のみ右上にトーストを表示するため,また比較対象はhashで比較(hashモードのため)
  const positionRightTopViews = ['#/entries/']
  positionRightTopViews.includes(window.location.hash)
    ? Vue.toasted.global.errorRightTop({ message }) : Vue.toasted.global.error({ message })
}

export { securedAxiosInstance, plainAxiosInstance }
